import './App.css';
import { React, useEffect } from 'react';
import SignIn from 'SignIn';


import { observer } from "mobx-react-lite"
import MainNavigation from 'pages/MainNavagation';
import CssBaseline from '@mui/material/CssBaseline';

import FormConst from 'constants/FormConst';
import { useAuthStore, useUserStore } from 'store/RootProvider'

/*
 * Module - App.js
 *
 * Description : 앱 시작 화면입니다. 
 *              쿠키에 저장되어 있는 사용자의 정보 갱신을  
 * 				스토어에 요청 하여 
 * 				로그인 페이지와 DashBoard를 
 * 				구분하여 렌더링 합니다. 
 *
 * 작성자 : Choi young ho. 
 * Created on Tue Jun 21 2022
 * Copyright (c) 2022 Renewhouse corp
 */

const App = observer(() => {
	const authStore = useAuthStore();
	const userStore = useUserStore();

	useEffect(() => {
		/**
		 * 사용자 정보를 요청 합니다. 
		 */
		const initUserInfo = async () => {
			try {
				console.log("[App]--------------------------- ");
				console.log("Try to Refresh User Info");
				console.log("[App]--------------------------- ");

				// 사용자 정보 갱신을 요청 합니다. 
				let result = await userStore.doRefreshUserInfo();
				if (result[FormConst.ERROR_MSG] != '') {
					// 로그인 화면으로 이동 합니다. 
					authStore.setLoginState(false);
					return;
				}
				// Dash Board를 첫화면으로 설정 합니다. 
				authStore.setLoginState(true);
			}

			catch (e) {
				console.log("[App]--------------------------- ");
				console.log("사용자 정보 조회 실패 로그인 페이지로 이동 합니다. ");
				console.log(e);
				console.log("[App]--------------------------- ");
				authStore.setLoginState(false);
				// ezExceptionHandler(e, navigation);
				return;
			}
		}
		initUserInfo();
	}, []);

	return (
		<div >
			<CssBaseline />
			{(authStore.isLogin)
				?
				<MainNavigation 
					style={{backgroundColor:'red'}}
				/>
				:
				<SignIn />
			}
		</div>
	);
})

export default App;
